export default Object.freeze({
  DRAFT: 'draft',
  LIVE: 'live',
  REPLAY: 'replay'
})
